import { combineLatest, forkJoin, iif as observableIif } from 'rxjs';
import {Component, OnInit, ViewChild} from '@angular/core';
import { Subcontractor } from '../shared/subcontractor.model';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../shared/services/navigation.service';
import { DriverService } from '../shared/driver.service';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { SubcontractorService } from '../shared/subcontractor.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CarrierService } from '../shared/carrier.service';
import { Carrier } from '../shared/carrier.model';
import { UserService } from '../shared/user.service';
import { finalize, map } from 'rxjs/operators';
import {UserSearchCriteria} from "../../shared/user-search-criteria";

@Component({
  selector: 'app-subcontractor-driver-list',
  templateUrl: './subcontractor-driver-list.component.html',
  styleUrls: ['./subcontractor-driver-list.component.scss']
})
export class SubcontractorDriverListComponent implements OnInit {

  carrierId: string;
  subcontractorId: string;

  selfCarrierMode = false;

  carrier: Carrier;
  subcontractors: Subcontractor[];

  selectedSubcontractor: Subcontractor;

  @ViewChild('userTable', { static: true})
  userTable;
  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.driverService.searchBySubcontractor(this.subcontractorId, page, pageSize, this.filters);

  constructor(
    private route: ActivatedRoute,
    private navigation: NavigationService,
    private userService: UserService,
    private carrierService: CarrierService,
    private driverService: DriverService,
    private subcontractorService: SubcontractorService,
    private loader: LoaderService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    combineLatest([this.route.params, this.route.data])
      .subscribe(([params, data]) => {
        if (data.selfCarrierMode) {
          this.selfCarrierMode = true;
        }

        this.carrierId       = params.carrierId;
        this.subcontractorId = params.subcontractorId;

        if (!this.selfCarrierMode && !this.carrierId) {
          this.toastr.error('Could not find the carrierId, redirecting to the carrier list', 'Error');
          this.navigation.carriers()
            .list()
            .go();
        }

        this.loader.startLoad(false);

        const carrierObservable        = observableIif(() => this.selfCarrierMode,
          this.userService.getSelf().pipe(map(currentUser => currentUser.carrier)),
          this.carrierService.getById(this.carrierId)
        );
        const subcontractorsObservable = observableIif(() => this.selfCarrierMode,
          this.subcontractorService.getSelfCarrierSubcontractors(),
          this.subcontractorService.getCarrierSubcontractors(this.carrierId)
        );

        forkJoin([carrierObservable, subcontractorsObservable])
          .pipe(finalize(() => this.loader.stopLoad()))
          .subscribe(([carrier, subcontractors]) => {
            this.carrier        = carrier;
            this.subcontractors = subcontractors;

            this.selectedSubcontractor = subcontractors.find(c => c.id === this.subcontractorId);
          }, (error: HttpErrorResponse) => {
            this.toastr.error(error.error.message || 'Error while fetching the subcontractors and drivers', 'Error');
          });

        if (this.userTable) {
          this.userTable.getPage(1, this.userTable.pageSize);
        }
      });
  }

  goToDrivers(subcontractorId: string): void {
    if (this.selfCarrierMode) {
      this.navigation.selfCarrier()
        .subcontractors()
        .drivers(subcontractorId)
        .list()
        .go();
    } else {
      this.navigation.carriers()
        .subcontractors(this.carrierId)
        .drivers(subcontractorId)
        .list()
        .go();
    }
  }

  goToCreateDriver(): void {
    if (this.selfCarrierMode) {
      this.navigation.selfCarrier()
        .subcontractors()
        .drivers(this.subcontractorId)
        .create()
        .go();
    } else {
      this.navigation.carriers()
        .subcontractors(this.carrierId)
        .drivers(this.subcontractorId)
        .create()
        .go();
    }
  }

  goToEditDriver(driverId: string): void {
    if (this.selfCarrierMode) {
      this.navigation.selfCarrier()
        .subcontractors()
        .drivers(this.subcontractorId)
        .edit(driverId)
        .go();
    } else {
      this.navigation.carriers()
        .subcontractors(this.carrierId)
        .drivers(this.subcontractorId)
        .edit(driverId)
        .go();
    }
  }

}
